export * from '../src/composites/wui-list-description/index.js';
//# sourceMappingURL=wui-list-description.js.map